<template>
  <UTooltip
    :text="text || undefined"
    :content="contentProps"
    :disabled="disabled || !text && !$slots.content"
    :disable-hoverable-content="!interactive"
  >
    <slot />

    <template v-if="$slots.content" #content>
      <slot name="content" />
    </template>
  </UTooltip>
</template>

<script lang="ts">
export default { name: 'OTooltip' }
</script>

<script setup lang="ts">
interface Props {
  text?: string | null
  placement?: 'top' | 'bottom' | 'left' | 'right'
  interactive?: boolean
  offset?: string | number
  disabled?: boolean
  touch?: boolean | unknown[]
  trigger?: string
}

const props = withDefaults(defineProps<Props>(), {
  text: null,
  placement: 'top',
  interactive: false,
  offset: 8,
  disabled: false,
  touch: false,
  trigger: 'mouseenter',
})

const contentProps = computed(() => {
  const sideOffset = typeof props.offset === 'string' && props.offset.includes(',')
    ? Number(props.offset.split(',')[1].trim())
    : Number(props.offset) || 8

  return {
    side: props.placement,
    sideOffset,
  }
})
</script>
